import { deviceLocal } from '@/privacy/deviceStorage';
/**
 * I-2102 (under I-2092): the last answer to "does one of this person's organisations require signing
 * out to remove their data from the device?", kept on the device. A sign-out that is not the Sign out
 * dialog (a revoked device, the Terms screen, mobile pairing, a lost credential) can happen before the
 * namespace tree is read; this is what it asks then. It names no organisation: a yes (`1`) or a no (`0`); no key means no answer.
 *
 * Registered `person`, owner rule: a different person signing in does not inherit it, and a removal of
 * the person's data takes it too (it is read again with the tree at the next sign-in).
 */
export const SIGN_OUT_REQUIRED_KEY = 'featit:signOutRequired';

/** `null` when the device has kept no answer: a sign-out then has nothing to go on (I-2102). */
export function readCachedSignOutRequired(): boolean | null {
  try {
    const kept = deviceLocal.getItem(SIGN_OUT_REQUIRED_KEY);
    return kept === '1' ? true : kept === '0' ? false : null;
  } catch {
    return null;
  }
}

export function cacheSignOutRequired(required: boolean): void {
  try {
    deviceLocal.setItem(SIGN_OUT_REQUIRED_KEY, required ? '1' : '0');
  } catch {
    // A device that will not keep it falls back to what the tree says, or to the default.
  }
}
